import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <a name="module-global--xmlhttprequest" id="module-global--xmlhttprequest"></a>
    <h1 {...{
      "id": "windowxmlhttprequest"
    }}>{`window.XMLHttpRequest`}</h1>
    <a name="new-module-global--xmlhttprequest-new" id="new-module-global--xmlhttprequest-new"></a>
    <h2 {...{
      "id": "xmlhttprequest"
    }}>{`XMLHttpRequest()`}</h2>
    <p>{`XMLHttpRequest objects are used to interact with servers.
You can retrieve data from a URL without having to do a full page refresh.
This enables a Web page to update just part of a page without disrupting what the user is doing.`}</p>
    <p>{`In order to leverage `}<inlineCode parentName="p">{`XMLHttpRequest`}</inlineCode>{`, update the `}<inlineCode parentName="p">{`manifest.json`}</inlineCode>{` with the `}<inlineCode parentName="p">{`network.domains`}</inlineCode>{` permission shown in the example section`}</p>
    <b> Example </b>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "permissions": {
      "network": {
          "domains": [
              "https://www.adobe.com",
              "https://*.adobeprerelease.com",
              "wss://*.myplugin.com"
          ]
      }
  }
}
`}</code></pre>
    <b>Limitation:</b>
From UXP v7.4.0 onwards `permissions.network.domains` does not support WildCards in top-level domains. Example:
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`"domains": [ "https://www.adobe.*", "https://www.*" ]
`}</code></pre>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`XMLHttpRequest`}</inlineCode>{` - New XMLHttpRequest object  `}</p>
    <a name="module-global--xmlhttprequest-responseurl" id="module-global--xmlhttprequest-responseurl"></a>
    <h2 {...{
      "id": "responseurl--string"
    }}>{`responseURL : `}<inlineCode parentName="h2">{`string`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
URL of the response or the empty string if the URL is null.
Any URL fragment present in the URL will be stripped away and will be the final URL obtained after any redirects.`}</p>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const xhr = new XMLHttpRequest();
xhr.onload = () => {
    console.log(xhr.responseURL);
};
xhr.open("GET", "https://www.adobe.com");
xhr.send();
`}</code></pre>
    <a name="module-global--xmlhttprequest-readystate" id="module-global--xmlhttprequest-readystate"></a>
    <h2 {...{
      "id": "readystate--number"
    }}>{`readyState : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
State of the XMLHttpRequest object. Available states are as follows.`}</p>
    <pre><code parentName="pre" {...{}}>{` UNSENT(0):           Object has been constructed.
 OPENED(1):           open() method has been successfully invoked.
 HEADERS_RECEIVED(2): All headers of a response have been received.
 LOADING(3):          Response body is being received.
 DONE(4):             Data transfer has been completed or something went wrong during the transfer.
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const xhr = new XMLHttpRequest();
xhr.onreadystatechange = () => {
    console.log(xhr.readyState);
};
xhr.open("GET", "https://www.adobe.com");
xhr.send();
`}</code></pre>
    <a name="module-global--xmlhttprequest-responsetext" id="module-global--xmlhttprequest-responsetext"></a>
    <h2 {...{
      "id": "responsetext--string"
    }}>{`responseText : `}<inlineCode parentName="h2">{`string`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
Text receive from a server following a request being sent.
If readyState is not either LOADING or DONE, it returns the empty string.`}</p>
    <p><strong parentName="p">{`Throws`}</strong>{`:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`DOMException`}</inlineCode>{` InvalidStateError if XMLHttpRequest.responseType is not set to either the empty string "" or "text".`}</li>
    </ul>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const xhr = new XMLHttpRequest();
xhr.addEventListener("load", () => {
    if (xhr.readyState === XMLHttpRequest.DONE && xhr.status === 200) {
        console.log(xhr.responseText);
    }
});
xhr.open("GET", "https://www.adobe.com");
xhr.send();
`}</code></pre>
    <a name="module-global--xmlhttprequest-responsexml" id="module-global--xmlhttprequest-responsexml"></a>
    <h2 {...{
      "id": "responsexml--document"
    }}>{`responseXML : `}<inlineCode parentName="h2">{`Document`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
Document containing the XML or HTML received by the request or
null if the request was unsuccessful, has not yet been sent, or
if the data cannot be parsed as XML or HTML.`}</p>
    <p><strong parentName="p">{`Throws`}</strong>{`:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`DOMException`}</inlineCode>{` If responseType is not either the empty string or "document".`}</li>
    </ul>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const xhr = new XMLHttpRequest();
xhr.onload = () => {
    if (xhr.readyState === XMLHttpRequest.DONE && xhr.status === 200) {
        console.log(xhr.responseXML);
    }
};
xhr.open("GET", "https://www.mydocumentserver.com");
xhr.responseType = "document";
xhr.send();
`}</code></pre>
    <a name="module-global--xmlhttprequest-response" id="module-global--xmlhttprequest-response"></a>
    <h2 {...{
      "id": "response--string--arraybuffer--blob--document--object"
    }}>{`response : `}<inlineCode parentName="h2">{`string`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="h2">{`ArrayBuffer`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="h2">{`Blob`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="h2">{`Document`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="h2">{`Object`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
Response's body content.
The value is null if the request is not yet complete or was unsuccessful.`}</p>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const xhr = new XMLHttpRequest();
xhr.onload = () => {
    if (xhr.readyState === XMLHttpRequest.DONE && xhr.status === 200) {
        console.log(xhr.response);
    }
};
xhr.open("GET", "https://www.adobe.com");
xhr.send();
`}</code></pre>
    <a name="module-global--xmlhttprequest-status" id="module-global--xmlhttprequest-status"></a>
    <h2 {...{
      "id": "status--number"
    }}>{`status : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
HTTP status code of the response.`}</p>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const xhr = new XMLHttpRequest();
xhr.onload = () => {
    console.log(xhr.status);
};
xhr.open("GET", "https://www.adobe.com");
xhr.send();
`}</code></pre>
    <a name="module-global--xmlhttprequest-statustext" id="module-global--xmlhttprequest-statustext"></a>
    <h2 {...{
      "id": "statustext--string"
    }}>{`statusText : `}<inlineCode parentName="h2">{`string`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
String containing the response's status message.
It will be an empty string if the request's readyState is UNSENT or OPENED.`}</p>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const xhr = new XMLHttpRequest();
xhr.onload = () => {
    console.log(xhr.statusText);
};
xhr.open("GET", "https://www.adobe.com");
xhr.send();
`}</code></pre>
    <a name="module-global--xmlhttprequest-timeout" id="module-global--xmlhttprequest-timeout"></a>
    <h2 {...{
      "id": "timeout--number"
    }}>{`timeout : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p>{`Number of milliseconds a request can take before automatically being terminated.
Default value is 0, which means there is no timeout.`}</p>
    <a name="module-global--xmlhttprequest-timeout" id="module-global--xmlhttprequest-timeout"></a>
    <h2 {...{
      "id": "timeout"
    }}>{`timeout`}</h2>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const xhr = new XMLHttpRequest();
xhr.open("GET", "https://www.adobe.com");
xhr.ontimeout = (e) => {
    console.log("xhr timed out");
};
xhr.timeout = 2000;  // 2,000 milliseconds
xhr.send();
`}</code></pre>
    <a name="module-global--xmlhttprequest-responsetype" id="module-global--xmlhttprequest-responsetype"></a>
    <h2 {...{
      "id": "responsetype--string"
    }}>{`responseType : `}<inlineCode parentName="h2">{`string`}</inlineCode></h2>
    <p>{`Type of data contained in the response.
Available types are as follows.`}</p>
    <pre><code parentName="pre" {...{}}>{` "" (Empty string): Default type. Same as "text".
 "text"           : Text in s string.
 "arrayBuffer"    : ArrayBuffer containing binary data.
 "blob"           : Blob object containing binary data.
 "document"       : HTML Document or XML Document based on MIME type of the received data.
 "json"           : Object created by parsing the contents of the received data as JSON.
`}</code></pre>
    <a name="module-global--xmlhttprequest-responsetype" id="module-global--xmlhttprequest-responsetype"></a>
    <h2 {...{
      "id": "responsetype"
    }}>{`responseType`}</h2>
    <p><strong parentName="p">{`Throws`}</strong>{`:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`DOMException`}</inlineCode>{` If readyState is either LOADING or DONE.`}</li>
    </ul>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const xhr = new XMLHttpRequest();
xhr.responseType = "blob";
`}</code></pre>
    <a name="module-global--xmlhttprequest-withcredentials" id="module-global--xmlhttprequest-withcredentials"></a>
    <h2 {...{
      "id": "withcredentials--boolean"
    }}>{`withCredentials : `}<inlineCode parentName="h2">{`boolean`}</inlineCode></h2>
    <p>{`Gets the value of the withCredentials. It indicates whether to send cookies on a HTTP request.
When the value is set to true, XMLHttpRequest sends cookies. Otherwise, cookies are not sent.
Note that unlike the specification, the default is true.`}</p>
    <a name="module-global--xmlhttprequest-withcredentials" id="module-global--xmlhttprequest-withcredentials"></a>
    <h2 {...{
      "id": "withcredentials"
    }}>{`withCredentials`}</h2>
    <p><strong parentName="p">{`Throws`}</strong>{`:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`DOMException`}</inlineCode>{` If readyState is neither UNSENT nor OPENED or send() is invoked.`}</li>
    </ul>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const xhr = new XMLHttpRequest();
xhr.withCredentials = true;
`}</code></pre>
    <a name="module-global--xmlhttprequest-upload" id="module-global--xmlhttprequest-upload"></a>
    <h2 {...{
      "id": "upload--xmlhttprequesteventupload"
    }}>{`upload : `}<inlineCode parentName="h2">{`XMLHttpRequestEventUpload`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
XMLHttpRequestEventUpload object that can be used to monitor an upload's progress.
The following events can be triggered on an upload object and used to monitor the upload.`}</p>
    <pre><code parentName="pre" {...{}}>{` 'loadstart'  : Upload has begun.
 'progress'   : Periodically delivered to indicate the amount of progress made so far.
 'abort'      : Upload operation was aborted.
 'error'      : Upload failed due to an error.
 'load'       : Upload completed successfully.
 'timeout'    : Upload timed out because a reply did not arrive within the time interval specified by the timeout.
 'loadend'    : Upload finished.
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const xhr = new XMLHttpRequest();
xhr.open("POST", "https://www.myserver.com");
xhr.upload.onprogress = (e) => {
    console.log(\`Uploading \${(e.loaded / e.total) * 100}%\`);
};
const arraybuffer = new ArrayBuffer(1024 * 1024);
// fill the arraybuffer with contents.
xhr.send(arraybuffer);
`}</code></pre>
    <a name="module-global--xmlhttprequest-abort" id="module-global--xmlhttprequest-abort"></a>
    <h2 {...{
      "id": "abort"
    }}>{`abort()`}</h2>
    <p>{`Aborts the request if it has already been sent.
When a request is aborted, its readyState is changed to UNSENT(0) and the request's status code is set to 0.`}</p>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const xhr = new XMLHttpRequest();
xhr.onabort = () => {
    console.log("aborted");
};
xhr.open("GET", "https://www.adobe.com");
xhr.send();
abortButton.addEventListener("click", () => {
    xhr.abort();
});
`}</code></pre>
    <a name="module-global--xmlhttprequest-getallresponseheaders" id="module-global--xmlhttprequest-getallresponseheaders"></a>
    <h2 {...{
      "id": "getallresponseheaders"
    }}>{`getAllResponseHeaders()`}</h2>
    <p>{`Returns sorted and combined response’s header list.
Each header field is defined by a group of `}{`[lower cased name]`}{`": "`}{`[value]`}{`"\\r\\n". Combined value is separated by ", ".`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`string`}</inlineCode>{` - All the response headers.`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const xhr = new XMLHttpRequest();
xhr.onreadystatechange = () => {
    if (xhr.readyState === XMLHttpRequest.HEADERS_RECEIVED) {
        console.log(xhr.getAllResponseHeaders());
    }
};
xhr.open("GET", "https://www.adobe.com");
xhr.send();
`}</code></pre>
    <a name="module-global--xmlhttprequest-getresponseheader" id="module-global--xmlhttprequest-getresponseheader"></a>
    <h2 {...{
      "id": "getresponseheadername"
    }}>{`getResponseHeader(name)`}</h2>
    <p>{`Returns the matching value of the given field name in response's header.
The search key value is case-insensitive.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`string`}</inlineCode>{` - Value of the given name in response's header list.`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Throws`}</strong>{`:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`TypeError`}</inlineCode>{` If the name parameter is not provided.`}</li>
    </ul>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`name`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Name to search in response's header list.`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const xhr = new XMLHttpRequest();
xhr.onreadystatechange = () => {
    if (xhr.readyState === XMLHttpRequest.HEADERS_RECEIVED) {
        console.log(xhr.getResponseHeader("Content-Type"));
    }
};
xhr.open("GET", "https://www.adobe.com");
xhr.send();
`}</code></pre>
    <a name="module-global--xmlhttprequest-open" id="module-global--xmlhttprequest-open"></a>
    <h2 {...{
      "id": "openmethod-url-async-user-password"
    }}>{`open(method, url, `}{`[async]`}{`, `}{`[user]`}{`, `}{`[password]`}{`)`}</h2>
    <p>{`Initializes a request or re-initializes an existing one.
Self-signed certificates are not currently supported for HTTPS connections.
Note that UXP does not support synchronous request, which means 'async' is false.`}</p>
    <p><strong parentName="p">{`Throws`}</strong>{`:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`DOMException`}</inlineCode>{` NotSupportedError if async parameter is false`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`DOMException`}</inlineCode>{` TypeError if method and url parameters are not provided`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`DOMException`}</inlineCode>{` SyntaxError if either method is not valid or url cannot be parsed.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`DOMException`}</inlineCode>{` SecurityError if method matches for CONNECT, TRACE or TRACK.`}</li>
    </ul>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`method`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`HTTP request method to use, such as "GET", "POST", "PUT", "DELETE", etc. Ignored for non-HTTP(S) URLs.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`url`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`String representing the URL to send the request to.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[async]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`true`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Optional Boolean parameter, defaulting to true, indicating whether or not to perform the operation asynchronously.                               If this value is false, the send() method does not return until the response is received.                               If true, notification of a completed transaction is provided using event listeners.                               This must be true if the multipart attribute is true, or an exception will be thrown.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[user]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`null`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Optional user name to use for authentication purposes; by default, this is the null value.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[password]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`null`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Optional password to use for authentication purposes; by default, this is the null value.`}</td>
        </tr>
      </tbody>
    </table>
    <a name="module-global--xmlhttprequest-overridemimetype" id="module-global--xmlhttprequest-overridemimetype"></a>
    <h2 {...{
      "id": "overridemimetypemimetype"
    }}>{`overrideMimeType(mimetype)`}</h2>
    <p>{`Specifies a MIME type other than the one specified in the response to be used
when interpreting the data being transferred in a request.
If it fails to parse the MIME type, "application/octet-stream" will be used to interpret the data.`}</p>
    <p><strong parentName="p">{`Throws`}</strong>{`:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`DOMException`}</inlineCode>{` If state is LOADING or DONE`}</li>
    </ul>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`mimetype`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`MIME type to use instead of the one specified in the response. Since Only UTF-8 is supported for charset of text encoding, MIME type’s parameters "charset" with other values than 'UTF-8' is not valid.`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const xhr = new XMLHttpRequest();
xhr.onload = () => {
    console.log(xhr.response);
    console.log(xhr.responseText);
};
xhr.open("GET", "https://www.myxmlserver.com");
xhr.overrideMimeType("text/plain");
xhr.send();
`}</code></pre>
    <a name="module-global--xmlhttprequest-setrequestheader" id="module-global--xmlhttprequest-setrequestheader"></a>
    <h2 {...{
      "id": "setrequestheaderheader-data"
    }}>{`setRequestHeader(header, data)`}</h2>
    <p>{`Adds a new request header or appends a value to an existing request header.
If a header is forbidden request header, it does nothing and just returns.
The following are forbidden request headers.`}</p>
    <pre><code parentName="pre" {...{}}>{` \`Accept-Charset\`
 \`Accept-Encoding\`
 \`Access-Control-Request-Headers\`
 \`Access-Control-Request-Method\`
 \`Connection\`
 \`Content-Length\`
 \`Cookie\`
 \`Cookie2\`
 \`Date\`
 \`DNT\`
 \`Expect\`
 \`Host\`
 \`Keep-Alive\`
 \`Origin\`
 \`Referer\`
 \`Set-Cookie\`
 \`TE\`
 \`Trailer\`
 \`Transfer-Encoding\`
 \`Upgrade\`
 \`Via\`
 If header starts with \`proxy-\` or \`sec-\`.
`}</code></pre>
    <p><strong parentName="p">{`Throws`}</strong>{`:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`DOMException`}</inlineCode>{` InvalidStateError if either state is not OPENED or send() is already invoked.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`DOMException`}</inlineCode>{` SyntaxError if a header is not a header name or if data is not a header value.`}</li>
    </ul>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`header`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Name of the header whose value is to be set.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`data`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Value to set as the body of the header.`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const xhr = new XMLHttpRequest();
xhr.open("GET", "https://www.mywebserver.com");
xhr.setRequestHeader("Accept", "text/xml");
xhr.send();
`}</code></pre>
    <a name="module-global--xmlhttprequest-send" id="module-global--xmlhttprequest-send"></a>
    <h2 {...{
      "id": "sendbody"
    }}>{`send(`}{`[body]`}{`)`}</h2>
    <p>{`Sends the request to the server.
Body can be a Blob, an ArrayBuffer, a TypedArray, a DataView, a FormData or a string.
If no value is specified for the body, a default value of null is used.`}</p>
    <p>{`There is a caveat for sending a FormData object. The files in the FormData object are being read after calling this method.
To ensure uploading files as-is, the file contents or files shouldn't be changed until uploading files to the server is done. see `}<a parentName="p" {...{
        "href": "#module-global-xmlhttprequest-upload"
      }}>{`XMLHttpRequest.upload`}</a>{`.
If there is a problem during reading files, the XMLHttpRequest transaction initiated by this method can be aborted with an error event fired.`}</p>
    <p><strong parentName="p">{`Throws`}</strong>{`:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`DOMException`}</inlineCode>{` InvalidStateError if either state is not OPENED or send() is already invoked.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`Error`}</inlineCode>{` Body is not a supported type.`}</li>
    </ul>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[body]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`*`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`\\null`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Body of data to be sent in the request.`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Example`}</strong>{` `}<em parentName="p">{`(Getting the resource as text)`}</em>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const xhr = new XMLHttpRequest();
xhr.addEventListener("load", () => {
    console.log(xhr.responseText);
});
xhr.open("GET", "https://www.adobe.com");
xhr.send();
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong>{` `}<em parentName="p">{`(Post request)`}</em>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const xhr = new XMLHttpRequest();
xhr.onreadystatechange = () => {
    if (xhr.readyState === XMLHttpRequest.DONE && xhr.status === 200){
        console.log(xhr.responseText);
    }
};
xhr.open("POST", "https://www.myserver.com");
xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
xhr.send("foo=bar&lorem=ipsum");
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      